import Layout from '@/components/layouts';
import Dashboard from '@/components/pages/Dashboard';
import LoginPage from '@/components/pages/login';

import FaqPage from '@/components/pages/community/faq/Faq';
import FaqAddPage from '@/components/pages/community/faq/FaqAdd';
import FaqDetailPage from '@/components/pages/community/faq/FaqDetail';
import FaqEditPage from '@/components/pages/community/faq/FaqEdit';

import LibraryPage from '@/components/pages/community/library/Library';
import LibraryAddPage from '@/components/pages/community/library/LibraryAdd';
import LibraryDetailPage from '@/components/pages/community/library/LibraryDetail';
import LibraryEditPage from '@/components/pages/community/library/LibraryEdit';

import AssignmentsPage from '@/components/pages/education/assignments/Assignments';
import AssignmentListPage from '@/components/pages/education/assignments/AssignmentList';

import CoursesPage from '@/components/pages/education/courses/Courses';
import CourseAddPage from '@/components/pages/education/courses/CourseAdd';
import CourseDetailPage from '@/components/pages/education/courses/CourseDetail';

import TrainingsPage from '@/components/pages/education/trainings/Trainings';
import TrainingDetailPage from '@/components/pages/education/trainings/TrainingDetail';
import TrainingAddPage from '@/components/pages/education/trainings/TrainingAdd';

import StudentsPage from '@/components/pages/students/Students';
import StudentDetailPage from '@/components/pages/students/StudentDetail';
import StudentAddPage from '@/components/pages/students/StudentAdd';

import ManagersPage from '@/components/pages/managers/Managers';
import ManagerDetailPage from '@/components/pages/managers/ManagerDetail';
import ManagerAddPage from '@/components/pages/managers/ManagerAdd';

import GroupsPage from '@/components/pages/groups/Groups';
import GroupDetailPage from '@/components/pages/groups/GroupDetail';
import GroupAddPage from '@/components/pages/groups/GroupAdd';
import GroupUsersPage from '@/components/pages/groups/GroupUsers';
import GroupManagersPage from '@/components/pages/groups/GroupManagers';

import ProjectsPage from '@/components/pages/education/projects/Project';
import ProjectDetailPage from '@/components/pages/education/projects/ProjectDetail';
import ProjectAddPage from '@/components/pages/education/projects/ProjectAdd';
import ProjectEditPage from '@/components/pages/education/projects/ProjectEdit';

import { Route, Routes } from 'react-router-dom';


const App = () => {
  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/login" element={<LoginPage />} />
          
          {/* 교육생 관리 */}
          <Route path="/students" element={<StudentsPage />} />
          <Route path="/students/new" element={<StudentAddPage />} />
          <Route path="/students/detail/:userId" element={<StudentDetailPage />} />

          {/* 매니저 관리 (FT/OPERATOR/ADMIN) */}
          <Route path="/managers" element={<ManagersPage />} />
          <Route path="/managers/new" element={<ManagerAddPage />} />
          <Route path="/managers/detail/:userId" element={<ManagerDetailPage />} />
          
          {/* 그룹 관리 */}
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/groups/new" element={<GroupAddPage />} />
          <Route path="/groups/detail/:groupId" element={<GroupDetailPage />} />
          <Route path="/groups/:groupId/users" element={<GroupUsersPage />} />
          <Route path="/groups/:groupId/managers" element={<GroupManagersPage />} />

          {/* 과정(동영상 강의) 관리 */}
          <Route path="/education/courses" element={<CoursesPage />} />
          <Route path="/education/courses/new" element={<CourseAddPage />} />
          <Route path="/education/courses/detail/:courseId" element={<CourseDetailPage />} />

          {/* 과제 관리 */}
          <Route path="/education/assignments" element={<AssignmentsPage />} />
          <Route path="/education/assignments/:courseId" element={<AssignmentListPage />} />

          {/* 진단 및 대응훈련 관리 */}
          <Route path="/education/trainings" element={<TrainingsPage />} />
          <Route path="/education/trainings/new" element={<TrainingAddPage />} />
          <Route path="/education/trainings/detail/:problemId" element={<TrainingDetailPage />} />

          {/* 프로젝트 개발훈련 관리 */}
          <Route path="/education/projects" element={<ProjectsPage />} />
          <Route path="/education/projects/new" element={<ProjectAddPage />} />
          <Route path="/education/projects/detail/:projectId" element={<ProjectDetailPage />} />
          <Route path="/education/projects/edit/:projectId" element={<ProjectEditPage />} />

          {/* 자료실 관리 */}
          <Route path="/community/library" element={<LibraryPage />} />
          <Route path="/community/library/new" element={<LibraryAddPage />} />
          <Route path="/community/library/detail/:libraryId" element={<LibraryDetailPage />} />
          <Route path="/community/library/edit/:libraryId" element={<LibraryEditPage />} />

          {/* FAQ 관리 */}
          <Route path="/community/faq" element={<FaqPage />} />
          <Route path="/community/faq/new" element={<FaqAddPage />} />
          <Route path="/community/faq/detail/:faqId" element={<FaqDetailPage />} />
          <Route path="/community/faq/edit/:faqId" element={<FaqEditPage />} />
        </Routes>
      </Layout>
    </>
  );
};

export default App;
